<template>
  <div class="breadcrumb normal arial centered light">
    <p v-if="queryType == 'filterable'">
      Stai vedendo: 
      repertorio <strong>{{r}}</strong>, 
      artista <strong>{{ar}}</strong>, 
      genere <strong>{{g}}</strong>, 
      pagina <strong>{{p}}</strong>, 
      ordine <strong>{{o}}</strong>
    </p>
    <p v-else-if="queryType == 'album'">
      Stai vedendo: album <strong>{{al}}</strong> di <strong>{{alAuthor}}</strong>
    </p>
    <p v-else-if="queryType == 'song'">
      Stai vedendo: brano <strong>{{b}}</strong> di <strong>{{bAuthor}}</strong>
    </p>
  </div>
</template>

<script>
export default {
  props: ['repertorio', 'artist', 'genre', 'orderBy', 'page', 'album', 'song', 'results'],
  data() {
    return {
      r: '',
      ar: '',
      g: '',
      al: '',
      b: '',
      o: '',
      p: 0,
      queryType: ''
    }
  },

  watch: {
    results: function(newVal, oldVal) {
      if(newVal && newVal.data && newVal.data.length > 0) {        
        this.update();
      }
    }

  },

  mounted() {
    if(this.results && this.results.data && this.results.data.length > 0) {      
      this.update();
    }
  },

  methods: {
    update: function() {
      this.queryType = 'filterable';

      if(this.album.activeId != -1) {
        this.queryType = 'album';
      } else
      if(this.song.activeId != -1) {
        this.queryType = 'song';
      }

      this.r = this.repertorio.data.find(r => r.id == this.repertorio.activeId).name;
      this.ar = this.artist.data.find(a => a.id == this.artist.activeId).name;
      this.g = this.genre.data.find(g => g.id == this.genre.activeId).name;
      this.o = this.orderBy.data.find(o => o.id == this.orderBy.activeId).name;
      this.p = this.page;

      let ad = this.album.selectedData;
      let bd = this.song.selectedData;
      
      this.al = this.album.activeId != -1 ? ad.title : 'Tutti';
      this.alAuthor = this.album.activeId != -1 ? ad.artist.name : 'tutti';

      this.b = this.song.activeId != -1 ? bd.title : 'Tutti';
      this.bAuthor = 'tutti';
      if(this.song.activeId != -1) {
        if(typeof bd.artist !== 'undefined') {
          this.bAuthor = bd.artist.name;
        } else
        if(typeof bd.album !== 'undefined' && typeof bd.album.artist !== 'undefined') {
          this.bAuthor = bd.album.artist.name;
        }
      }
    },

    toTitleCase: function(str) {
      return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/vue/components/CatalogResultsBreadcrumb.vue